import { Link } from "react-router-dom";
import { ChevronLeft, Download, FileText, Sparkles } from "lucide-react";
import "./PlaybookPage.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DOWNLOADS = [
  {
    key: "growth-playbook",
    title: "Growth Playbook — All in One",
    sub: "Master document · everything in a single PDF",
    tag: "START HERE",
    highlight: true,
  },
  {
    key: "fb-group-posts",
    title: "Facebook Group Posts",
    sub: "5 ready-to-post variations (HBCU, book club, homeschool, entrepreneur, local)",
  },
  {
    key: "reels-scripts",
    title: "TikTok & Reels Scripts",
    sub: "10 scripts, one per figure — post one per day for two weeks",
  },
  {
    key: "hbcu-outreach",
    title: "HBCU Department Email",
    sub: "Template + 20 target schools (Morehouse, Spelman, Howard, Morris, more)",
  },
  {
    key: "teacher-outreach",
    title: "Teacher & Librarian Email",
    sub: "Two templates — one for teachers, one for school & public librarians",
  },
  {
    key: "amazon-kdp",
    title: "Amazon KDP Setup Guide",
    sub: "10-step walkthrough to get your book on Amazon (free · biggest volume lever)",
  },
];

export default function PlaybookPage() {
  return (
    <div className="playbook-root" data-testid="playbook-root">
      <div className="playbook-topbar">
        <Link to="/" className="playbook-back" data-testid="playbook-back-home">
          <ChevronLeft size={16} /> Back to site
        </Link>
        <div className="playbook-brand">
          <Sparkles size={12} /> PRIVATE · NJ ONLY
        </div>
      </div>

      <header className="playbook-hero">
        <h1>Your Growth Playbook</h1>
        <p>
          Six ready-to-send PDFs for your outreach. Save them to your phone,
          email them, or forward as attachments. Not linked from anywhere on
          the public site.
        </p>
      </header>

      <div className="playbook-grid">
        {DOWNLOADS.map((d) => (
          <a
            key={d.key}
            href={`${API}/download/growth/${d.key}`}
            className={`pb-card ${d.highlight ? "is-highlight" : ""}`}
            target="_blank"
            rel="noreferrer"
            data-testid={`playbook-dl-${d.key}`}
          >
            {d.tag && <div className="pb-tag">{d.tag}</div>}
            <FileText size={26} className="pb-icon" />
            <div className="pb-body">
              <div className="pb-title">{d.title}</div>
              <div className="pb-sub">{d.sub}</div>
            </div>
            <div className="pb-download">
              <Download size={18} />
            </div>
          </a>
        ))}
      </div>

      <div className="playbook-footer">
        <p>
          <strong>How to use these on your phone:</strong>
        </p>
        <ol>
          <li>Tap any card above — the PDF opens in a new tab</li>
          <li>
            Tap the share icon → <em>Save to Files</em> (iPhone) or{" "}
            <em>Download</em> (Android)
          </li>
          <li>
            To email: from Files/Downloads, tap the PDF → share → <em>Mail</em>{" "}
            → attach and send
          </li>
          <li>
            To post to Facebook / IG: open the PDF, screenshot the specific
            section (e.g., one Reel script), then paste the text into your
            post
          </li>
        </ol>
        <p className="pb-hint">
          💡 Bookmark this page. It&apos;s at{" "}
          <strong>africanamericanxperience.com/playbook</strong> and won&apos;t
          appear in any menu on the public site.
        </p>
      </div>
    </div>
  );
}
